import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout.component';
import { HeaderComponent } from './header/header.component';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { SkeletonScreenModule } from '@daysmart/angular-skeleton-screen';
import { NotificationModule } from '../shared/notification/notification.module';
import { MatDialogModule } from '@angular/material/dialog';
import { QaModule } from '@daysmart/angular-qa-module';

@NgModule({
    declarations: [LayoutComponent, HeaderComponent],
    imports: [
        CommonModule,
        AppRoutingModule,
        NotificationModule,
        SkeletonScreenModule,
        MatDialogModule,
        QaModule,
    ],
    exports: [LayoutComponent],
})
export class LayoutModule {}
